import { render, staticRenderFns } from "./Apareca.vue?vue&type=template&id=270d187f"
import script from "./Apareca.vue?vue&type=script&lang=js"
export * from "./Apareca.vue?vue&type=script&lang=js"
import style0 from "./Apareca.vue?vue&type=style&index=0&id=270d187f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports